module.exports = __webpack_public_path__ + "50c4d84db23b537ac1f793da8f32015a.png";